// extracted by mini-css-extract-plugin
module.exports = {"root":"Lead-module--root--3-Rhj","spaceTop":"Lead-module--spaceTop--1wSuc"};